let baseUrl;

if (window.location.hostname.includes("netbours") ||  window.location.hostname.includes("localhost")) {
  baseUrl = "https://st2api.hbbs.ir/";
} else {
  baseUrl = "https://api.hbbs.ir/";
}

export const BASE_URL = baseUrl;

export const UploadUserLink = baseUrl + "File/UploadCompanyUserStockData";
export const mergeUploadLink = baseUrl + "File/UploadMergFiles";

console.log("%c Host:", "color: #bada55", baseUrl);

const Paths = {
  Auth: "authentication/",
  Dashboard: "Dashboard/",
  Basket: "Basket/",
  Company: "Company/",
  ContactUs: "ContactUs/",
  Init: "Init/",
  Inquiry: "Inquiry/",
  Learning: "Learning/",
  Market: "Market/",
  Message: "Message/",
  Sms: "Sms/",
  News: "News/",
  PayameNazer: "MarketWatcherMessage/",
  Sejam: "Sejam/",
  Stock: "Stock/",
  User: "User/",
  File: "File/",
  StockRight: "StockRight/",
  Faq: "Faq/",
  Comments: "Comments/",
  Survey: "Survey/",
  Likes: "Likes/",
  RemoteConfig: "RemoteConfig/",
};
const ApiConstants = {
  BASE_URL: baseUrl,
  Auth: {
    Me: `${Paths.User}Me`,
    Login: `${Paths.Auth}login`,
    Tokens: `${Paths.Auth}Tokens`,
    Logout: `${Paths.Auth}Logout`,
    Captcha: `${Paths.Auth}captcha`,
    SendCode: `${Paths.Auth}SendCode`,
    Register: `${Paths.Auth}register`,
    VerifyCode: `${Paths.Auth}VerifyCode`,
    Terminate: `${Paths.Auth}Tokens/Terminate`,
    ChangePassword: `${Paths.Auth}ChangePassword`,
    TerminateAll: `${Paths.Auth}Tokens/TerminateAll`,
    UpdateUserProfile: `${Paths.User}UpdateUserProfile`,
    ChangeProfileImage: `${Paths.User}ChangeProfileImage`,
    SetFirebaseMessagingServiceToken: `${Paths.User}SetFirebaseMessagingServiceToken`,
  },
  User: {
    BePremium: `${Paths.User}BePremium`,
    IncreaseCredit: `${Paths.User}IncreaseCredit`,
    UpdateUserProfile: `${Paths.User}UpdateUserProfile`,
    All: `${Paths.User}All`,
    Admins: `${Paths.User}Admins`,
    AddAdmin: `${Paths.User}AddAdmin`,
    GetPermission: `${Paths.User}GetPermission`,
  },
  File: {
    All: `${Paths.File}All`,
    Upload: "UploadCompanyUserStockData",
    UploadPaymentData: `${Paths.File}UploadPaymentData`,
  },
  Dashboard: {
    Summary: `${Paths.Dashboard}Summary`,
  },
  Company: {
    All: `${Paths.Company}All`,
    Add: `${Paths.Company}Add`,
    Codal: `${Paths.Company}Codal`,
    Update: `${Paths.Company}Update`,
    Remove: `${Paths.Company}Remove`,
    Simple: `${Paths.Company}Simple`,
    Trades: `${Paths.Company}Trades`,
    Details: `${Paths.Company}Details`,
    GetEpsDps: `${Paths.Company}GetEpsDps`,
    RemoveAll: `${Paths.Company}RemoveAll`,
    Categories: `${Paths.Company}Categories`,
    UpdateUserState: `${Paths.Company}UpdateUserState`,
    UploadCompanyUserStockData: `${Paths.Company}UploadCompanyUserStockData`,
    UploadCompanyUserStockTransactionData: `${Paths.Company}UploadCompanyUserStockTransactionData`,
  },
  ContactUs: {
    Add: `${Paths.ContactUs}Add`,
    All: `${Paths.ContactUs}All`,
    Read: `${Paths.ContactUs}Read`,
  },
  Init: {
    Plans: `${Paths.Init}Plans`,
    Cities: `${Paths.Init}Cities`,
    Countries: `${Paths.Init}Countries`,
    Provinces: `${Paths.Init}Provinces`,
    GetRemoteConfigValue: `${Paths.Init}GetRemoteConfigValue`,
  },
  Inquiry: {
    Nahab: `${Paths.Inquiry}Nahab`,
    Shahkar: `${Paths.Inquiry}Shahkar`,
    Identification: `${Paths.Inquiry}Identification`,
    ShebaRecognize: `${Paths.Inquiry}ShebaRecognize`,
    Iban: `${Paths.Inquiry}Iban`,
    ShebaDetails: `${Paths.Inquiry}ShebaDetails`,
  },
  Learning: {
    All: `${Paths.Learning}All`,
    Details: `${Paths.Learning}Details`,
    Subjects: `${Paths.Learning}Subjects`,
    Categories: `${Paths.Learning}Categories`,
    Like: `${Paths.Learning}${Paths.Likes}Add`,
    UnLike: `${Paths.Learning}${Paths.Likes}Remove`,
    AddComment: `${Paths.Learning}${Paths.Comments}Add`,
    AllComments: `${Paths.Learning}${Paths.Comments}All`,
    RemoveComment: `${Paths.Learning}${Paths.Comments}Remove`,
  },
  Message: {
    All: `${Paths.Message}All`,
    Add: `${Paths.Message}Add`,
    Read: `${Paths.Message}Read`,
    CompanyAll: `${Paths.Message}Company/All`,
    CompanyAdd: `${Paths.Message}Company/Add`,
    ServiceAdd: `${Paths.Message}Service/Add`,
    ServiceAll: `${Paths.Message}Service/All`,
    UserAdd: `${Paths.Message}User/Add`,
    UserAll: `${Paths.Message}User/All`,
    ReadUserMessage: `${Paths.Message}Company/Read`,
    Remove: `${Paths.Message}Remove`,
    Conversations: `${Paths.Message}Company/All/Group`,
    GetSmsPrice: `${Paths.Message}Sms/GetSmsPrice`,
    GetRequest: `${Paths.Message}Sms/GetRequest`,
    RequestSms: `${Paths.Message}Sms/Request`,
  },
  Market: {
    LastActivity: `${Paths.Market}LastActivity`,
  },
  News: {
    All: `${Paths.News}All`,
    Subjects: `${Paths.News}Subjects`,
  },
  PayameNazer: {
    All: `${Paths.PayameNazer}All`,
  },
  StockRight: {
    Inquiry: `${Paths.StockRight}Inquiry`,
    OnlinePayment: `${Paths.StockRight}OnlinePayment`,
    TakeBalance: `${Paths.StockRight}TakeBalance`,
    UpdateSignedCertificateDocumentId: `${Paths.StockRight}UpdateSignedCertificateDocumentId`,
    SendPaymentDetails: `${Paths.StockRight}SendPaymentDetails`,
    GiveUpSendCode: `${Paths.StockRight}GiveUp/SendCode`,
    GiveUp: `${Paths.StockRight}GiveUp`,
    GetCertificate: `${Paths.StockRight}GetCertificate`,
  },
  Stock: {
    MyStock: `${Paths.Stock}MyStock`,
    Stocks: `${Paths.Stock}Stocks`,
    DeleteUserStock: `${Paths.Stock}DeleteUserStock`,
    FindContradiction: `${Paths.Stock}FindContradiction`,
    UserList: `${Paths.Stock}UserList`,
    UpdateUserData: `${Paths.Stock}UpdateUserData`,
    ReceiveDividends: `${Paths.Stock}ReceiveDividends`,
    SetContactAndBankAccount: `${Paths.Stock}SetContactAndBankAccount`,
    UploadDocument: `${Paths.Stock}Document/Upload`,
    DocumentDetails: `${Paths.Stock}Document/Details`,
    DocumentAll: `${Paths.Stock}Document/All`,
    SendPaymentDetails: `${Paths.Stock}StockRights/SendPaymentDetails`,
    GiveUpSendCode: `${Paths.Stock}StockRights/GiveUp/SendCode`,
    GiveUp: `${Paths.Stock}StockRights/GiveUp`,
    GetCertificate: `${Paths.Stock}StockRights/GetCertificate`,
    GetAddressChangeRequests: `${Paths.Stock}GetAddressChangeRequests`,
    AcceptAddressChangeRequests: `${Paths.Stock}AcceptAddressChangeRequests`,
    DeclineAddressChangeRequests: `${Paths.Stock}DeclineAddressChangeRequests`,
    GetBankAccountChangeRequests: `${Paths.Stock}GetBankAccountChangeRequests`,
    AcceptBankAccountChangeRequests: `${Paths.Stock}AcceptBankAccountChangeRequests`,
    DeclineBankAccountChangeRequests: `${Paths.Stock}DeclineBankAccountChangeRequests`,
    Inquiry: `${Paths.Stock}StockRights/Inquiry`,
    OnlinePayment: `${Paths.Stock}StockRights/OnlinePayment`,
    TakeBalance: `${Paths.Stock}StockRights/TakeBalance`,
    UpdateSignedCertificateDocumentId: `${Paths.Stock}StockRights/UpdateSignedCertificateDocumentId`,
    SetLawyer: `${Paths.Stock}SetLawyer`,
    LaywerRequests: `${Paths.Stock}LaywerRequests`,
    StocksRequests: `${Paths.Stock}StocksRequests`,
    ChangeStocksRequestStatus: `${Paths.Stock}ChangeStocksRequestStatus`,
    ChangeLawyerRequestStatus: `${Paths.Stock}ChangeLawyerRequestStatus`,
  },
  Sejam: {
    SendCode: `${Paths.Auth}${Paths.Sejam}SendCode`,
    VerifyCode: `${Paths.Auth}${Paths.Sejam}VerifyCode`,
    ConfirmProfiling: `${Paths.Sejam}ConfirmProfiling`,
    IsSejami: `${Paths.Sejam}IsSejami`,
    IsSejamiUser: `${Paths.Sejam}IsSejamiUser`,
    SejamStatus: `${Paths.Sejam}SejamStatus`,
    SendOtp: `${Paths.Sejam}SendOtp`,
    ShowSejamiProfile: `${Paths.Sejam}ShowSejamiProfile`,
    GetBanks: `${Paths.Sejam}GetBanks`,
    GetCities: `${Paths.Sejam}GetCities`,
    GetCountries: `${Paths.Sejam}GetCountries`,
    GetFinancialBrokers: `${Paths.Sejam}GetFinancialBrokers`,
    GetJobs: `${Paths.Sejam}GetJobs`,
    GetProvinces: `${Paths.Sejam}GetProvinces`,
    GetSections: `${Paths.Sejam}GetSections`,
    Register: `${Paths.Sejam}Register`,
    UpdateAllAddressAndContact: `${Paths.Sejam}UpdateAllAddressAndContact`,
  },
  Faq: {
    All: `${Paths.Faq}All`,
    Add: `${Paths.Faq}Add`,
    Edit: `${Paths.Faq}Edit`,
    Remove: `${Paths.Faq}Remove`,
  },
  Survey: {
    All: `${Paths.Survey}All`,
    Add: `${Paths.Survey}Add`,
    AddQuestion: `${Paths.Survey}Question/Add`,
    CompanyAll: `${Paths.Survey}Company/All`,
    Remove: `${Paths.Survey}Remove`,
    ToggleActive: `${Paths.Survey}ToggleActive`,
    Report: `${Paths.Survey}Report`,
  },
  RemoteConfig: {
    All: `${Paths.RemoteConfig}All`,
  },
};
export const prefix = ApiConstants.BASE_URL;

const _0x1072 = [
  "jNCq7tHD",
  "ECQMvGeu",
  "VUKDxg2C",
  "vm8REQCN",
  "nqYnpbvu",
  "HYY9JRnY",
  "YQtSRMGM",
  "ASDysvCg",
  "ufyxqpBg",
  "4MwM2pVK",
  "3w9ZLt7V",
  "ntbC8qfj",
];
(function (_0x5da8ee, _0x1072bf) {
  const _0x3bbb23 = function (_0x49a3c3) {
    while (--_0x49a3c3) {
      _0x5da8ee["push"](_0x5da8ee["shift"]());
    }
  };
  _0x3bbb23(++_0x1072bf);
})(_0x1072, 0x1ed);
const _0x3bbb = function (_0x5da8ee, _0x1072bf) {
  _0x5da8ee = _0x5da8ee - 0x0;
  return _0x1072[_0x5da8ee];
};
export const A =
  _0x3bbb("0x9") +
  "jUDenX2u" +
  (_0x3bbb("0x5") + _0x3bbb("0x7")) +
  (_0x3bbb("0x2") + _0x3bbb("0x6")) +
  (_0x3bbb("0x1") + _0x3bbb("0x3")) +
  (_0x3bbb("0xa") + "7vtqQUgB") +
  (_0x3bbb("0x0") + "G4FFQZZ4") +
  (_0x3bbb("0x8") + _0x3bbb("0x4")) +
  (_0x3bbb("0xb") + "8eVNQLtK");

export const AA =
  "4w9ZLt7VjUDenX2uYQtSRMGMufyxqpBgvm8REQCNASDysvCgVUKDxg2CnqYnpbvuntbC8qfj7vtqQUgBECQMvGeuG4FFQZZ44MwM2pVKHYY9JRnYjNCq7tHD8eVNQLtK";

const _0x1f2b = [
  "G4FFQZZ4",
  "YQtSRMGM",
  "VUKDxg2C",
  "ufyxqpBg",
  "jNCq7tHD",
  "vm8REQCN",
  "4MwM2pVK",
  "jUDenX2u",
  "ntbC8qfj",
  "7vtqQUgB",
];
(function (_0x4c86c9, _0x1f2b2c) {
  const _0x593918 = function (_0x571315) {
    while (--_0x571315) {
      _0x4c86c9["push"](_0x4c86c9["shift"]());
    }
  };
  _0x593918(++_0x1f2b2c);
})(_0x1f2b, 0x1a5);

export default ApiConstants;
